import { ServiceItem, ServiceInventoryItem } from '@app/modules/service-items/service-items.entity';

export type Reward = {
  id: number;
  day: number;
  serviceItem: ServiceItem;
  minDeposit: number;
  minDepositPeriod: number;
  depositConditionMet?: boolean;
  missingAmount?: number;
  userReward?: UserReward;
  status?: RewardStatus;
  nextRewardAt?: string|null;
  isNext?: boolean;
};

export enum RewardStatus {
  DEFAULT,
  AVAILABLE,
  UNAVAILABLE,
  AVAILABLE_SOON,
  USABLE,
  TAKEN
}

export type NextReward = {
  reward: Reward;
  nextRewardAt: string|null;
};

export type UserReward = {
  id: number;
  reward: Reward;
  status: UserRewardStatus;
  inventoryServiceItem: ServiceInventoryItem|null;
  createdAt: string;
};

export const enum UserRewardStatus {
  TAKEN = 1,
  USED = 2
}

export type CheckedUser = {
  avatar: Avatar;
  daysPassed: number;
  /** Time to pass in seconds */
  timeToPass: number;
  createdAt: string;
};

export type Avatar = {
  id: number;
  fileName: string;
};

export namespace ApiResponse {
  export interface CheckSteamPhoto {
    steamPhoto: string;
    checkedUser: CheckedUser;
  }

  export interface RewardsList {
    rewards: Reward[];
    userRewards: UserReward[];
    nextRollAt: string;
    avatars: Avatar[];
    avatarCheckedUser: CheckedUser|null;
  }

  export interface TakenReward {
    userReward: UserReward;
  }
}